export class Address {
  constructor(
    public street: string,
    public barangay: string,
    public province: string,
    public city: string,
    public zipCode: string | object
  ) { }
}
